import { partnerCatalogCategories } from '@/Models';
import Resources from '@/Resources';
import { mapEnumFromResourceToOptions, displayNameFromResources } from '@/Utils/EnumUtility';

/**
 * Shared PartnerCatalogCategory option/name helpers (admin screens + public directory).
 * Names are resolved from the localized `PartnerCatalogCategories` resources; values are the
 * enum ids (ints) that go on the wire.
 *
 * @returns {{
 *   categoryOptions: Object<string, number>,
 *   categoryItems: Array<{ name: string, value: number }>,
 *   categoryName: (id: number) => (string|number),
 *   notSelectedCategories: (selectedIds: number[]) => Array<{ name: string, value: number }>
 * }}
 */
export function usePartnerCategories() {
    const categoryOptions = mapEnumFromResourceToOptions(Resources.PartnerCatalogCategories, partnerCatalogCategories);
    const categoryItems = Object.entries(categoryOptions).map(([name, value]) => ({ name, value }));

    const categoryName = (id) => {
        const category = partnerCatalogCategories[id];
        return category ? displayNameFromResources(Resources.PartnerCatalogCategories, category) : id;
    };
    const notSelectedCategories = (selectedIds = []) =>
        categoryItems.filter(category => !selectedIds.includes(category.value));

    return { categoryOptions, categoryItems, categoryName, notSelectedCategories };
}
